import * as React from "react";

;
export const InactiveRadioUnchecked = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#E7E6E9" fillRule="evenodd" d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0Z" clipRule="evenodd" /></svg>;